<template>
  <div class="page-container content-430">
    <div class="search-wrapper header-wrapper-430">
      <div class="page-search">
        <Form
          ref="searchForm"
          label-position="right"
          :label-width="0"
          class="search-list-430 search-wrapper-430"
        >
          <Row class="relative" type="flex" flex="end">
            <FormItem label="">
              <Input
                v-model="nameListValue"
                placeholder="请输入"
                clearable
                class="search-selectInput-430"
              >
                <Select
                  slot="prepend"
                  v-model="nameSelectValue"
                  placeholder="请选择课程名称/ID"
                  class="search-select-430"
                >
                  <Option
                    v-for="(item, index) in nameList"
                    :key="index"
                    :value="item.value"
                  >{{ item.label }}</Option>
                </Select></Input>
            </FormItem>
            <FormItem label="">
              <Select
                v-model="eduId"
                filterable
                placeholder="请选择教育局"
                :disabled="!searchConds.orgId || searchConds.orgId == -1"
                clearable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in eduList"
                  :key="index"
                  :value="item.orgId"
                >{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="">
              <choose-course-type
                ref="chooseCourseTypeRef"
                :disabled="chooseCTdisabled"
                :placeholder="`请选择课程类别`"
                :org-id="searchConds.orgId"
                @on-change="handleChooseCourseTypeChange"
              >
              </choose-course-type>
            </FormItem>
            <FormItem label="">
              <div v-if="portOrg === 3" :title="portOrg3Name">
                {{ portOrg3Name }}
              </div>
              <RemoteSelect
                v-else
                v-model="searchConds.orgId"
                placeholder="请选择课程提供方"
                :remote-method="getListOrgOpeEduSch"
                :loading="loadingOrg"
                @clear="getListOrgOpeEduSch('')"
                @visible-change="loadAllOrgList"
              >
                <el-option
                  v-for="item in orgNameList"
                  :key="item.orgId"
                  :label="item.name"
                  :value="item.orgId"
                >
                </el-option>
              </RemoteSelect>
            </FormItem>

            <FormItem v-if="portOrg !== 2" label="">
              <RemoteSelect
                v-model="searchConds.schoolId"
                placeholder="请选择上架学校"
                :remote-method="remoteGetSchoolList"
                :loading="loadingSchool"
                style="width: 250px"
                clearable
                @clear="remoteGetSchoolList('')"
                @change="handleChangeSch"
                @visible-change="loadAllList"
              >
                <el-option
                  v-for="(item, index) in schoolNameList"
                  :key="index"
                  :label="item.name"
                  :value="item.orgId"
                >
                </el-option>
              </RemoteSelect>
            </FormItem>
            <FormItem v-if="portOrg == 3" label="">
              <Select
                v-model="searchConds.isShelves"
                placeholder="请选择上架状态"
                clearable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in courseStateList"
                  :key="index"
                  :value="item.value"
                >{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem v-if="portOrg == 0 || portOrg == 2" label="">
              <Select
                v-model="searchConds.isShelves"
                placeholder="请选择上架状态"
                clearable
                class="search-select-430"
              >
                <Option
                  v-for="(item, index) in courseStateList"
                  :key="index"
                  :value="item.value"
                >{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="">
              <CascaderYearTerms
                ref="cascaderYearTerms"
                :placeholder="`请选择课程资源学期`"
                :clearable="true"
                @on-change="hanldChangYearTerm"
              ></CascaderYearTerms>
            </FormItem>
            <Button type="primary" @click="handleSearch">查询</Button>
            <Button class="search-430" @click="handleReset">重置</Button>
          </Row>
        </Form>
      </div>
      <div class="table-title-special-430 flex justify-content_end">
        <div style="display: flex; align-items: center">
          <Button
            v-if="portOrg != 1 && portOrg != 2"
            type="primary"
            @click="handleAddCourse('add')"
          >新建课程</Button>
          <Button
            v-if="portOrg != 1 && portOrg != 3"
            type="primary"
            style="margin-left: 16px"
            @click="handleExport"
          >导出</Button>
          <Icon
            type="md-settings"
            size="22"
            color="#488ffa"
            style="margin-left: 16px; cursor: pointer"
            @click="handleColumn"
          ></Icon>
        </div>
      </div>
    </div>
    <div class="table">
      <Table
        border
        :columns="columns"
        :data="courseList"
        :loading="tableLoading"
        :max-height="tableHeight"
      >
        <template slot="courseLevel" slot-scope="{ row }">
          <span>{{ courseLevelName[row.courseLevel] }}</span>
        </template>
        <template slot="courseName" slot-scope="{ row }">
          <TablePoptip :content="row.courseName"> </TablePoptip>
        </template>
        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>

        <template slot="courseTypeKind" slot-scope="{ row }">
          <TablePoptip :content="getcourseType(row.courseTypeKind, row)">
          </TablePoptip>
        </template>
        <!-- 学校端隐藏上架学校一列 -->
        <template slot="schoolName" slot-scope="{ row }">
          <div v-if="row.schoolName" class="school">
            <div style="width: 150px">
              <span
                style="line-height: 20px"
                v-html="cutout(row.schoolName)"
              ></span>
            </div>
            <div
              v-if="row.schoolName.length > 3"
              class="more"
              @click="handleLookSchool(row.schoolName)"
            >
              更多
            </div>
          </div>
        </template>
        <template slot="isShelves" slot-scope="{ row }">
          <div v-if="row.isShelves === 1" class="state-green-430">
            <span></span><!-- 文字前的点 -->
            <span>已上架</span>
          </div>
          <div v-if="row.isShelves === 0" class="state-red-430">
            <span></span>
            <span>已下架</span>
          </div>
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <Button
            v-if="portOrg !== 1"
            type="text"
            size="small"
            style="margin-right: 5px; color: #488ffa"
            @click.stop="handleAddCourse('copy', row)"
          >复制</Button>
          <Button
            v-if="portOrg != 1"
            type="text"
            size="small"
            style="margin-right: 5px; color: #488ffa"
            @click="handleAddCourse('update', row)"
          >编辑</Button>
          <Button
            v-if="(portOrg === 2 && row.isShelves != 1) || portOrg === 0"
            v-show="theUserIdentity !== 'org'"
            type="text"
            size="small"
            style="margin-right: 5px; color: #488ffa"
            @click="handleShelf(row)"
          >上架</Button>
          <Button
            type="text"
            size="small"
            style="margin-right: 5px; color: #488ffa"
            @click="handleCod(row)"
          >课程商品</Button>
          <Button
            v-if="
              (row.orgName === orgName && portOrg === 2) ||
                portOrg === 0 ||
                portOrg === 3
            "
            type="text"
            size="small"
            style="margin-right: 5px; color: #ff0000"
            @click="handleRemove(row, index)"
          >删除</Button>
        </template>
      </Table>
    </div>
    <div class="modal">
      <Modal
        v-model="toShelfShow"
        title="资源上架"
        ok-text="批量上架"
        @on-ok="handleBatchShelf"
        @on-cancel="handleCancelToShelf"
      >
        <div class="shelfLi" style="margin-bottom: 20px; display: flex">
          <Input
            v-model="schoolNameShelf"
            class="shelf_input"
            placeholder="请输入学校名称"
            style="width: 200px"
            clearable
          ></Input>
          <Cascader
            v-model="areaData"
            :data="regionDataList"
            style="width: 200px; margin: 0 10px"
            placeholder="所属行政区"
            @on-change="areaChange"
          ></Cascader>
          <Button type="primary" @click="handleSearchShelf">搜索</Button>
        </div>
        <div class="table">
          <Table
            border
            :columns="columnShelf"
            :data="shelfList"
            max-height="520"
            :loading="modalLoading"
            @on-selection-change="tableColumnsChange"
          >
          </Table>
        </div>
        <div style="margin-top: 20px">已选择:{{ selectionNum }}所学校</div>
        <div class="paging">
          <Page
            :current="pageShelf.pageNum"
            :total="pageShelf.total"
            :page-size="pageShelf.pageSize"
            show-total
            show-sizer
            @on-change="pageChangeShelf"
            @on-page-size-change="pageChangeSize"
          >
          </Page>
        </div>
      </Modal>
    </div>

    <div class="paging">
      <Page
        :current="page.pageNum"
        :total="page.total"
        :page-size="page.pageSize"
        show-total
        show-elevator
        show-sizer
        :page-size-opts="pageSizeOpts"
        @on-page-size-change="onPageSizeChange"
        @on-change="pageChange"
      ></Page>
    </div>

    <LookSchoolModal
      :visible="isLookSchool"
      :school="lookSchoolList"
      @close="isLookSchool = false"
    ></LookSchoolModal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import courseCenterApi from '@/request/courseCenter/index.js';
import resourcesApi from '@/request/courseCenter/courseCenterApi.js';
import LookSchoolModal from './assets/components/LookSchool.vue';
import resourcesManagementApi from '@/request/courseCenter/resources';
// import ChooseColumns from '@c/ChooseColumns'
import { courseTypeData } from './assets/data/resources';
import { regionDataList } from '@/utils/dictionary';
import {
  trainingTypeList,
  courseStateList,
  nameList,
  columns,
  columnShelf
} from './assets/data/courseTable.js';
import { getTableColumns } from '@utils/tool';
import RemoteSelect from '@c/RemoteSelect';
import orderCenterApi from '@/request/orderCenter/index.js';
import ChooseCourseType from '@c/searchBlock/ChooseCourseType.vue';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { downLoadByBlob, downLoadErrorByBlob } from '@/pages/assetsModules/common.js';

export default {
  name: 'CourseCenterResourcesCourseTable',
  components: {
    LookSchoolModal,
    RemoteSelect,
    ChooseCourseType,
    CascaderYearTerms
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      courseLevelName: {
        1: '基础班',
        2: '提高班',
        3: '精英班',
        4: '其他'
      },
      courseTypeL: [],
      courseTypeDataInit: courseTypeData,
      courseTypeDataUse: [],
      courseTypeList: [
        ['', '艺术', '科技', '体育', '美术', '综合实践'],
        ['', '早托', '午托', '晚托', '全托']
      ],
      isLookSchool: false, // 查看更多学校
      lookSchoolList: [],
      portOrg: null, // 0运营端 2学校端 3机构
      orgName: null,
      columns,
      columnKey: '', // 表格头部 key
      columnShelf,
      trainingTypeList,
      courseStateList,
      nameList,
      orgId: '',
      schoolNameShelf: '',
      selectionNum: 0,
      nameSelectValue: 'courseName',
      nameListValue: '',
      toShelfShow: false,
      loading: true,
      tableLoading: false,
      orgNameList: [],
      courseList: [],
      schoolNameList: [],
      loadingSchool: false, // 远程搜索框
      searchConds: {
        trainingType: -1,
        courseId: '',
        courseName: '',
        schoolName: '',
        schoolId: '',
        orgName: '',
        orgId: -1,
        isShelves: -1
      },
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      pageShelf: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      courseId: [],
      shelfList: [],
      activeselection: 0,
      schoolIdArr: [],
      courseIdShelf: '',
      orgIdShelf: '',
      schoolPageInfo: {
        total: 0
      },
      areaData: [],
      regionDataList: [], // 行政区数据
      areaCode: '',
      eduList: [],
      eduId: '',
      portOrg3Name: '',
      num: 0,
      courseTableSch: '', // 查询的学校名称
      // isShowChooseColumns: false,
      yearTerms: [],
      modalLoading: false,
      selectRow: {}, // 选中表格的哪一行
      isFirst: true,
      loadingOrg: false
    };
  },
  computed: {
    ...mapGetters(['theUserIdentity', 'userInfo', 'routeTitle']),
    chooseCTdisabled() {
      return !this.eduId || (this.portOrg == 1 && (!this.searchConds.orgId || this.searchConds.orgId == -1));
    }
  },
  watch: {
    'searchConds.orgId'(newVal) {
      // 教育局监听
      if (this.portOrg !== 1) {
        this.eduId = '';
        if (newVal && Number(newVal) !== -1) {
          this.getRelEduFun(newVal);
        }
      } else {
        this.courseTypeL = [];
        this.courseTypeDataUse = JSON.parse(
          JSON.stringify(this.courseTypeDataInit)
        );
      }
    },
    eduId(newVal) {
      this.courseTypeL = [];
      this.courseTypeDataUse = JSON.parse(
        JSON.stringify(this.courseTypeDataInit)
      );
      this.searchConds.trainingType = '';
      this.searchConds.courseTypeKind = '';
      this.searchConds.courseTypeId = '';
    }
  },
  created() {
    this.courseTypeDataUse = JSON.parse(
      JSON.stringify(this.courseTypeDataInit)
    );
    // 行政区数据
    this.regionDataList = [...regionDataList];
    // 记住选择的课程提供方
    let schoolSelectList = {};
    const schoolSelect = JSON.parse(localStorage.getItem('schoolSelectList'));
    if (schoolSelect) {
      schoolSelectList = schoolSelect;
    }
    if (schoolSelectList.orgId) {
      this.searchConds.orgId = schoolSelectList.orgId;
    }

    this.portOrg = Number(localStorage.getItem('portOrg'));
    console.log('this.portOrg：', this.portOrg);
    this.orgName = JSON.parse(localStorage.getItem('userInfo')).orgName;
    this.orgId = JSON.parse(localStorage.getItem('userInfo')).orgId;
    if (localStorage.getItem('courseTableSch') && this.portOrg !== 2) {
      this.searchConds.schoolId = localStorage.getItem('courseTableSch');
    }
    if (this.portOrg === 1) {
      this.columns = this.columns.filter(col => col.slot !== 'action');
      this.eduId = this.orgId;
    }
    if (this.portOrg === 2) {
      this.columns = this.columns.filter(col => col.key !== 'schoolName');
    }
    this.columnKey = `${this.$route.path}${this.portOrg}`;
    this.columns = getTableColumns(this.columnKey, this.columns);

    console.log('this.$route');
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CourseCenterResourcesCourseTable');
    next();
  },
  activated() {
    this.handleSearch();
  },
  mounted() {
    // 刷新上架之后的上架状态
    this.$bus.$on('change', () => {
      this.getClassCoursePageFun();
    });
  },
  destroyed() {
    this.$bus.$off('change');
  },
  methods: {
    ...mapMutations(['SET_CACHEROUTE', 'PUSH_CACHEROUTE']),
    loadAllList(val) {
      if (!val) {
        this.remoteGetSchoolList('');
      }
    },
    remoteGetSchoolList(query) {
      this.getSchoolList(query);
    },
    handleQueryChange(v) {
      if (v === '') {
        this.searchConds.schoolName = '';
        this.searchConds.schoolId = '';
      }
    },
    handleChangeSch(val) {
      this.courseTableSch = val;
      if (typeof val === 'undefined' || val == 'undefined') {
        val = '全部';
      }
    },
    // 计算月份
    getNowDayInfo() {
      const nowTime = new Date();
      const year = nowTime.getFullYear();
      const month = nowTime.getMonth() + 1;
      const date = nowTime.getDate();
      if (month > 8 || (month === 8 && date >= 15)) {
        return `${year}-${year + 1}`;
      } else {
        return `${year - 1}-${year}`;
      }
    },
    // 教育局
    async getRelEduFun(orgId) {
      const res = await resourcesManagementApi.getRelEdu({
        orgId: orgId
      });
      if (res.status === 200) {
        this.eduList = res.message;
      }
    },
    handleCourseType(value, select) {
      switch (value.length) {
        case 1:
          this.searchConds.trainingType = value[0];
          this.searchConds.courseTypeKind = '';
          this.searchConds.courseTypeId = '';
          break;
        case 2:
          this.searchConds.trainingType = value[0];
          this.searchConds.courseTypeKind = value[1];
          this.searchConds.courseTypeId = '';
          break;
        case 3:
          this.searchConds.trainingType = value[0];
          this.searchConds.courseTypeKind = value[1];
          this.searchConds.courseTypeId = value[2];
          break;
        default:
          break;
      }
    },
    handleChooseCourseTypeChange(types) {
      const { courseTypes, classType, courseTypeKind, courseTypeId } = types;
      this.searchConds.trainingType = classType;
      this.searchConds.courseTypeKind = courseTypeKind;
      this.searchConds.courseTypeId = courseTypeId;
      this.courseTypeL = courseTypes;
    },
    // 自定义级联显示内容
    format(labels, selectedData) {
      return labels.join('-');
    },
    async handleLoadData(item, callback) {
      item.loading = true;
      let resp = {};
      switch (this.theUserIdentity) {
        // 学校端的时候
        case 'school':
          resp = await resourcesApi.courseTypeListByOffer({
            offerId: this.searchConds.orgId,
            courseTypeKind: item.value,
            eduId: this.eduId
          });
          break;
        case 'org':
          // 机构端
          resp = await resourcesManagementApi.getCourseTypeTapList({
            orgId: this.eduId,
            courseTypeKind: item.value,
            eduId: this.eduId
          });
          break;
        default:
          // 非学校端的时候(后面可能会不同端不同的接口，这里预留以后的判断)
          resp = await resourcesManagementApi.getCourseTypeTapList({
            orgId: this.searchConds.orgId,
            courseTypeKind: item.value,
            eduId: this.eduId
          });
          break;
      }
      const data = resp.message.map(course => {
        return {
          label: course.courseTypeName,
          value: course.courseTypeId
        };
      });
      if (resp.message.length) {
        item.children = data;
        item.loading = false;
      } else {
        item.children = [
          {
            label: '无',
            value: ''
          }
        ];
        item.loading = false;
      }
      callback();
    },
    // 处理课程二级类
    getcourseType(courseTypeKind, row) {
      let str1 = '';
      let str2 = '';
      let str3 = '';
      if (row.trainingType == 1) {
        str1 = '素质课程';
      } else if (row.trainingType) {
        str1 = '托管课程';
      }
      if (courseTypeKind) {
        const str = courseTypeKind.toString();
        if (str.length === 2) {
          str2 =
            this.courseTypeList[Number(str.slice(0, 1)) - 1][
              Number(str.slice(1, 2))
            ];
        }
      }
      if (str2) {
        str2 = '/' + str2;
      }
      if (row.courseTypeName) {
        str3 = '/' + row.courseTypeName;
      }
      return str1 + str2 + str3;
    },
    // 选择市区
    areaChange(data) {
      this.areaCode = data[data.length - 1];
    },
    // 换行
    cutout(cellValue) {
      const arr = cellValue.slice(0, 3);
      return arr.toString().replace(/\,/g, '</br>');
    },
    // 查看更多上架学校
    handleLookSchool(shcoolList) {
      this.isLookSchool = true;
      this.lookSchoolList = shcoolList;
      console.log('shcoolList', shcoolList);
    },
    // 删除
    async handleRemove(row, index) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '您确定要删除该行数据吗？',
        onOk: () => {
          this.handleDlect(row);
        },
        onCancel: () => { }
      });
    },
    // 删除接口
    async handleDlect(row) {
      const params = {
        courseId: row.courseId
      };
      const res = await courseCenterApi.deleteCourse(params);
      if (res.status === 200) {
        this.$Message.success('删除成功');
        this.getClassCoursePageFun();
      }
    },
    loadAllOrgList(val) {
      if (!val) {
        this.getListOrgOpeEduSch('');
      }
    },
    async getListOrgOpeEduSch(orgName = '') {
      this.loadingOrg = true;
      const params = {
        pageNum: 1,
        pageSize: 100,

        orgName,
        yearCode: this.yearTerms.length ? this.yearTerms[0] : '',
        termCode: this.yearTerms.length ? this.yearTerms[1] : ''
      };
      if (+this.portOrg !== 0 && this.portOrg !== 2) {
        params.orgType = 4;
      }
      const res = await orderCenterApi.getWxOrgList(params);
      this.loadingOrg = false;
      if (res.status === 200) {
        const arr = [{ orgId: -1, name: '全部课程提供方' }];
        this.orgNameList = [
          ...arr,
          ...res.message.list.map(item => {
            return { orgId: item.orgId, name: item.name || item.orgName };
          })
        ];
      }
    },
    // 提供方
    async getCourseProviderListFun() {
      if (this.portOrg !== 3) {
        this.getListOrgOpeEduSch();
      }
    },
    // 获取上架学校
    getSchoolList(query) {
      query ? (this.loadingSchool = true) : '';
      const queryTrue = {
        searchStr: query,
        yearCode: this.yearTerms.length ? this.yearTerms[0] : '',
        termCode: this.yearTerms.length ? this.yearTerms[1] : ''
      };
      switch (this.portOrg) {
        case 0:
        case 1:
        case 3:
          this.getSchoolNameListByedu(queryTrue);
          break;
        default:
          break;
      }
    },
    // 上架学校（教育局）
    async getSchoolNameListByedu(queryTrue) {
      const params = Object.assign({
        pageNum: 1,
        pageSize: 100,
        orgType: 1,
        orgName: queryTrue.searchStr
      }, queryTrue);
      // queryTrue ? (params.searchStr = queryTrue) : '';
      const res = await orderCenterApi.getWxOrgList(params);
      if (res.status === 200) {
        // const arr = [{ name: '全部上架学校', orgId: '-1' }];
        this.schoolNameList = [
          // ...arr,
          ...res.message.list.map(item => {
            return { name: item.name || item.orgName, orgId: item.orgId };
          })
        ];
      }
      this.loadingSchool = false;
    },
    // 上架学校（运营）
    // async getSchoolNameListByOperate(queryTrue) {
    //   const params = Object.assign({
    //     pageNum: this.schoolPageInfo.pageNum,
    //     pageSize: this.schoolPageInfo.pageSize
    //   },queryTrue);
    //   const res = await courseCenterApi.getSchoolNameListByOperate(params);
    //   if (res.status === 200) {
    //     const arr = [{ name: '全部上架学校' }];
    //     this.schoolNameList = [
    //       ...arr,
    //       ...res.message.list.map(item => {
    //         return { name: item.name };
    //       })
    //     ];
    //   }
    //   this.loadingSchool = false;
    // },
    // 处理 选择学校 iview select 问题
    handleSelectSchHack() {
      this.$nextTick(() => {
        if (this.num < 2) {
          try {
            const dom = document
              .getElementsByClassName('sch-form-item')[0]
              .getElementsByClassName('ivu-select-item-selected')[0];
            dom.click();
          } catch (err) { }
        }
        this.num++;
      });
    },
    // 列表点击上架
    handleShelf(row) {
      if (+this.portOrg === 2) {
        this.courseIdShelf = row.courseId;
        this.orgIdShelf = row.orgId;
        this.schoolIdArr = [this.userInfo.orgId];
        this.putCourseFun();
        return;
      }
      this.activeselection = [];
      this.schoolIdArr = [];
      this.selectionNum = 0;
      this.selectRow = row;
      this.courseIdShelf = row.courseId;
      this.orgIdShelf = row.orgId;
      this.toShelfShow = true;
      this.pageShelf.pageNum = 1;
      this.getCoursePutAwayPageFun(null);
    },

    handleSearchShelf() {
      const params = {};
      params.name = this.schoolNameShelf;
      params.areaCode = this.areaCode;

      this.getCoursePutAwayPageFun(params);
    },
    // 资源上架-分页
    async getCoursePutAwayPageFun(name = null) {
      const obj = {
        pageNum: this.pageShelf.pageNum,
        pageSize: this.pageShelf.pageSize,
        orgId: this.orgIdShelf,
        areaCode: this.areaCode
      };
      const params = { ...obj, ...name };
      this.modalLoading = true;
      const res = await courseCenterApi.getCoursePutAwayPage(params);
      this.modalLoading = false;
      if (res.status === 200) {
        this.pageShelf.total = Number(res.message.total);
        this.shelfList = res.message.list.map(item => {
          item._disabled = this.selectRow.schoolName ? this.selectRow.schoolName.includes(item.name) : false;
          return item;
        });
      }
    },
    // 取消批量上架
    handleCancelToShelf() { },
    // 选中的学校ID
    tableColumnsChange(selection) {
      this.activeselection = selection;
      this.schoolIdArr = selection.map(item => {
        return item.schoolId;
      });
      this.selectionNum = this.schoolIdArr.length;
    },
    handleBatchShelf() {
      if (this.selectionNum < 1) {
        this.$Message.warning('请至少选择一个学校！');
      } else {
        this.putCourseFun();
      }
    },

    // 资源上架
    async putCourseFun() {
      const params = {
        orgId: this.orgIdShelf, // 机构ID,
        courseId: this.courseIdShelf, // 课程ID,
        schoolIds: this.schoolIdArr
      };
      const res = await courseCenterApi.putCourse(params);
      if (res.status === 200) {
        this.$Message.success('上架成功');
        this.$bus.$emit('change'); // 刷新状态
      }
    },
    getListParameter() {
      let params;
      params = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      };
      this.eduId ? (params.eduId = this.eduId) : '';
      this.searchConds.schoolName ? '' : (this.searchConds.schoolName = '');
      switch (this.nameSelectValue) {
        case 'courseName':
          this.searchConds = Object.assign({}, this.searchConds, {
            courseName: this.nameListValue,
            courseId: ''
          });
          break;
        case 'courseId':
          this.searchConds = Object.assign({}, this.searchConds, {
            courseId: this.nameListValue,
            courseName: ''
          });
          break;
      }
      const searchArr = Object.assign({}, searchArr, this.searchConds);
      Object.keys(searchArr).forEach(item => {
        if (searchArr[item] === -1) {
          searchArr[item] = '';
        }
        if (searchArr[item] === '全部') {
          searchArr[item] = '';
        }
        if (searchArr[item] === '全部上架学校') {
          searchArr[item] = '';
        }
      });
      params = Object.assign({}, params, searchArr);
      if (this.yearTerms.length) {
        params.yearCode = this.yearTerms[0];
        params.termCode = this.yearTerms[1];
      }
      return params;
    },
    // 平台资源管理-分页
    async getClassCoursePageFun() {
      const params = this.getListParameter();
      this.tableLoading = true;
      const res = await courseCenterApi.getClassCoursePage(params);
      this.tableLoading = false;
      if (res.status === 200) {
        this.page.total = Number(res.message.total);
        this.courseList = res.message.list;
      }
    },
    hanldChangYearTerm(v) {
      console.log('v:', v, this.searchConds);
      this.searchConds.orgId = -1;
      this.searchConds.schoolName = '';
      this.searchConds.schoolId = '';
      this.yearTerms = v;
      // 课程提供方
      this.getCourseProviderListFun();
      // 学校
      this.remoteGetSchoolList();
      // 搜索
      if (this.isFirst) {
        this.handleSearch();
      }
    },
    // onYearTermInit() {
    //   this.handleSearch()
    // },
    // 查询
    handleSearch() {
      this.isFirst = false;
      // 记住选择的学校
      let schoolSelectList = {};
      const schoolSelect = JSON.parse(localStorage.getItem('schoolSelectList'));
      this.yearTerms = this.$refs.cascaderYearTerms.getResult();
      if (schoolSelect) {
        schoolSelectList = schoolSelect;
      }
      schoolSelectList.orgId = this.searchConds.orgId;
      localStorage.setItem(
        'schoolSelectList',
        JSON.stringify(schoolSelectList)
      );
      this.courseTableSch
        ? localStorage.setItem('courseTableSch', this.courseTableSch)
        : '';
      this.getClassCoursePageFun();
    },
    // 翻页
    pageChange(current) {
      this.page.pageNum = current;
      this.getClassCoursePageFun();
    },
    onPageSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageNum = 1;
      this.getClassCoursePageFun();
    },
    // 上架翻页
    pageChangeShelf(current) {
      this.pageShelf.pageNum = current;
      this.getCoursePutAwayPageFun();
    },
    pageChangeSize(current) {
      this.pageShelf.pageSize = current;
      this.pageShelf.pageNum === 1 && this.getCoursePutAwayPageFun();
    },
    // 重置
    handleReset() {
      this.searchConds = {
        trainingType: -1,
        courseId: '',
        courseName: '',
        schoolName: '全部',
        schoolId: '',
        orgName: '',
        orgId: Number(this.portOrg) === 3 ? this.searchConds.orgId : -1,
        isShelves: -1
      };
      this.yearTerms = this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.handleDefault();
      this.courseTableSch = '';
      localStorage.removeItem('courseTableSch');
      if (this.portOrg !== 1) {
        this.eduId = '';
      } else {
        this.courseTypeL = [];
        this.courseTypeDataUse = JSON.parse(
          JSON.stringify(this.courseTypeDataInit)
        );
        this.searchConds.trainingType = '';
        this.searchConds.courseTypeKind = '';
        this.searchConds.courseTypeId = '';
      }

      this.nameSelectValue = 'courseName';
      this.nameListValue = '';
      this.getClassCoursePageFun();
      this.num = 0;
      this.handleSelectSchHack();
      return this.searchConds;
    },
    // 新建-编辑课程
    handleAddCourse(type, row) {
      console.log('row', row);
      switch (type) {
        case 'add':
          this.$router.push({
            name: 'courseCenter_resources_courseTable_edit'
          });
          break;
        case 'update': {
          this.$router.push({
            name: 'courseCenter_resources_courseTable_edit', query: { courseId: row.courseId, isShelves: row.isShelves }
          });
          // const { href } = this.$router.resolve({
          //   name: 'courseCenter_resources_courseTable_edit',
          //   query: { courseId: row.courseId, isShelves: row.isShelves }
          // });
          // window.open(href);
          break;
        }
        // 批量新建课程
        case 'more':
          this.$router.push({
            name: 'courseCenter_resources_courseTable_batchNewCourses'
          });
          break;
        case 'copy':
          this.$router.push({
            name: 'courseCenter_resources_courseTable_edit', query: { courseId: row.courseId, isShelves: row.isShelves, copy: 1 }
          });
          // const { href } = this.$router.resolve({
          //   name: 'courseCenter_resources_courseTable_edit',
          //   query: {
          //     courseId: row.courseId,
          //     isShelves: row.isShelves,
          //     copy: 1
          //   }
          // });
          // window.open(href);
          break;
      }
    },
    // 课程资源导出
    async handleExport() {
      const params = this.getListParameter();
      delete params.pageSize;
      delete params.pageNum;
      this.$Spin.show();
      const res = await courseCenterApi.getCourseDefineExport(params);
      this.$Spin.hide();
      downLoadByBlob(res);
    },
    // 跳转课程商品
    handleCod(row) {
      const { href } = this.$router.resolve({
        name: 'courseCenter_resources_courseTable_edit',
        query: {
          courseId: row.courseId,
          isShelves: row.isShelves,
          tab: 'good'
        }
      });
      window.open(href);
    },
    // 设置表格 表头
    handleColumn() {
      // this.isShowChooseColumns = true
      this.$ChooseColumns430({
        columns: this.columns,
        columnKey: this.columnKey,
        Ok: res => {
          console.log(res);
          this.columns = res.columns;
        },
        Cancel: () => { }
      });
    }
    // onChooseColumnsOk(columns) {
    //   this.isShowChooseColumns = false

    //   this.columns = columns

    // }
  }
};
</script>

<style lang="scss" scoped>
/deep/.ivu-modal {
  width: 650px !important;
}
.modal .shelfLi {
  display: flex;
}
.page-container {
  min-height: 100%;
  padding: 0 30px 30px;
  .flex-between {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .li {
      display: flex;
      align-items: center;
      margin-right: 40px;
    }
  }
  .port-org-name {
    flex-shrink: 0;
    width: 250px;
    color: #aaaaaa;
  }
  .label {
    flex-shrink: 0;
    margin-right: 5px;
    width: 80px;
    text-align: right;
  }
  .school {
    display: flex;
    .more {
      height: 24px;
      line-height: 20px;
      margin-left: 10px;
      margin-top: 5px;
      background-color: #f2f2f2;
      padding: 2px 5px;
      cursor: pointer;
    }
  }
  .search-wrapper-bottom {
    display: flex;
    justify-content: flex-start;
    .li {
      display: flex;
      align-items: center;
      margin-right: 40px;
    }
  }
}
</style>
